import { type Toast } from '#app/components/Toasts/types.js';
import { IconContainer } from './Toast.styles.js';
import { RocketEmoji } from '@contra/icons/emojis';
import {
  AlertCircleIcon,
  AlertTriangleIcon,
  CheckCircleIcon,
  InfoIcon,
} from '@contra/icons/icons';

type ToastIconProps = {
  readonly icon: Toast['icon'];
  readonly type: Toast['type'];
};

const getIcon = (type: ToastIconProps['type']): JSX.Element => {
  const svgProps = {
    focusable: false,
    size: 24,
  };

  switch (type) {
    case 'content': {
      return <RocketEmoji {...svgProps} />;
    }

    case 'error': {
      return <AlertCircleIcon {...svgProps} />;
    }

    case 'success': {
      return <CheckCircleIcon {...svgProps} />;
    }

    case 'warning': {
      return <AlertTriangleIcon {...svgProps} />;
    }

    default: {
      return <InfoIcon {...svgProps} />;
    }
  }
};

export const ToastIcon = ({ icon, type }: ToastIconProps) => {
  if (icon !== undefined) {
    return <IconContainer $type={type}>{icon}</IconContainer>;
  }

  return <IconContainer $type={type}>{getIcon(type)}</IconContainer>;
};
